export class TimeoutError extends Error {
    constructor(message) {
        super(message);
        this.type = 'timeout';
        this.name = 'TimeoutError';
        Object.setPrototypeOf(this, TimeoutError.prototype);
    }
}
export const withTimeout = (wrappedFetch) => (input, options) => {
    const { controller, timeoutMS, ...restOptions } = options || {};
    const pendingRequest = wrappedFetch(input, restOptions);
    if (!timeoutMS) {
        return pendingRequest;
    }
    return new Promise((res, rej) => {
        setTimeout(() => {
            if (controller) {
                // The `reason` property should be supported from Node v17.2.0 and v16.14.0.
                // Our types in this project does not reflect these versions.
                // @ts-ignore
                controller.abort(new TimeoutError(`Operation timed out after ${timeoutMS}ms`));
            }
            else {
                rej(new TimeoutError(`Operation timed out after ${timeoutMS}ms`));
            }
        }, timeoutMS);
        pendingRequest.then(res, rej);
    });
};
//# sourceMappingURL=timeout.js.map